import { render, staticRenderFns } from "./BottleSizeCreate.vue?vue&type=template&id=200b5f67"
import script from "./BottleSizeCreate.vue?vue&type=script&lang=ts"
export * from "./BottleSizeCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports